import styled from 'styled-components';
import { Link } from '~/components/Atoms';
import { getThemeByPath } from '~/utils';

const spacingMedium = getThemeByPath('spacings.medium');

const bkpTablet = getThemeByPath('breakpoints.tablet');

const mediumSpacing = getThemeByPath('spacings.medium');

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${mediumSpacing}px;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  @media (max-width: ${bkpTablet}px) {
    margin: 0 ${mediumSpacing}px;
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0000;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: ${spacingMedium}px;
  width: 100%;
`;

export const MenuItemWrapper = styled.div`
  display: flex;
  margin: ${spacingMedium}px 0;
`;

export const MenuItem = styled(Link).attrs({
  variant: 'headline4',
})``;
